"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var errorConstants = {
  DATA_TEST_ERROR: 'error-message',
  DATA_TESTID_ERROR: 'error-message',
  ERROR_CLASSNAME: 'error'
};
var _default = exports["default"] = errorConstants;